import { render, staticRenderFns } from "./VerticalTable.vue?vue&type=template&id=5b123660&scoped=true&"
import script from "./VerticalTable.vue?vue&type=script&lang=js&"
export * from "./VerticalTable.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTable.vue?vue&type=style&index=0&id=5b123660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b123660",
  null
  
)

export default component.exports